import { useRef, useState } from "react";
import "./css/otpInput.css";
//
const OtpInput = ({ onOtpChange }) => {
  //
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputsRef = useRef([]);

  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (value.length > 1) return; 

    const newOtp = [...otp];
    newOtp[index] = value; 
    setOtp(newOtp);
    onOtpChange(newOtp.join(""));

    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      //
      inputsRef.current[index - 1]?.focus();
    }
  };

  return (
    <div className="otp-input-container mt-2">
      {Array.from({ length: 6 }).map((_, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          className="otp-input"
          ref={(el) => (inputsRef.current[index] = el)}
          onChange={(e) => handleInputChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
        />
      ))}
    </div>
  );
};

export default OtpInput;
